import { Contact } from '@features/contacts/types/contact'

export const getContactName = (contacts: Contact[], contactId: string): string | undefined =>
  contacts.find(({ id }) => id === contactId)?.name
